export interface AgentData {
  iconKey: string;
  title: string;
  desc: string;
  coins?: string[];
  avatars?: string[];
  more?: string;
  featured?: boolean;
}

export const AGENTS: AgentData[] = [
  {
    iconKey: "yield",
    title: "DeFi Yield Optimizer",
    desc: "Scans protocols globally and auto-reallocates capital for maximum APY.",
    coins: ["uniswap.png", "aave.png", "lido.png", "etherfi.svg"],
    more: "+20 more",
    featured: true,
  },
  {
    iconKey: "arbitrage",
    title: "Prediction Market Arb Bot",
    desc: "Monitors prediction markets for mispriced outcomes and executes arbitrage.",
    coins: ["polymarket.png", "kalshi.svg", "predictit.svg", "drift.svg"],
    more: "+5 more",
  },
  {
    iconKey: "social",
    title: "Reply Guy",
    desc: "AI social engagement agent that manages your presence on X natively.",
    avatars: [
      "https://unavatar.io/x/aaboronin",
      "https://unavatar.io/x/VitalikButerin",
      "https://unavatar.io/x/sandeepnailwal",
      "https://unavatar.io/x/cz_binance",
    ],
    more: "+200 more",
  },
  {
    iconKey: "portfolio",
    title: "Portfolio Tracker",
    desc: "Aggregates all holdings across wallets and exchanges with real-time PnL.",
    coins: ["okx.png", "coinbase.png", "metamask.png", "phantom.svg", "backpack.svg", "trustwallet.svg"],
    more: "+50 more",
  },
  {
    iconKey: "alert",
    title: "Smart Alerts",
    desc: "Custom triggers for price movements, whale activity, and new launches.",
    coins: ["eth.png", "bnb.png", "sol.png", "polygon.png", "chainlink.png", "btc.png"],
    more: "+30 more",
  },
  {
    iconKey: "sniper",
    title: "Sniper Bot",
    desc: "Monitors blockchain for new launches and auto-executes based on criteria.",
    coins: ["sniper1.svg", "sniper2.svg", "jupiter.png", "sniper4.svg"],
    more: "+50 more",
  },
];
